 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientCreditCard',
	};

	var $form;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		$form.find('.number-edit-toggle').on('click', function click(e)
		{
			e.preventDefault();

			if ($('#clientcreditcard-number_edit').val() === '0') {
				$form.find('.number-static').addClass('hidden');
				$form.find('.number-edit').removeClass('hidden');
				$('#clientcreditcard-number_edit').val('1');

				$('#clientcreditcard-number').focus();
			} else {
				$form.find('.number-edit').addClass('hidden');
				$form.find('.number-static').removeClass('hidden');
				$('#clientcreditcard-number_edit').val('0');

				$('#clientcreditcard-number').val('');
			}
		});

		$form.find('.ccv-edit-toggle').on('click', function click(e)
		{
			e.preventDefault();

			if ($('#clientcreditcard-ccv_edit').val() === '0') {
				$form.find('.ccv-static').addClass('hidden');
				$form.find('.ccv-edit').removeClass('hidden');
				$('#clientcreditcard-ccv_edit').val('1');

				$('#clientcreditcard-ccv').focus();
			} else {
				$form.find('.ccv-edit').addClass('hidden');
				$form.find('.ccv-static').removeClass('hidden');
				$('#clientcreditcard-ccv_edit').val('0');

				$('#clientcreditcard-ccv').val('');
			}
		});

		setTimeout(function triggered() {
			$('#clientcreditcard-credit_card_type_id').trigger('change');
		}, 100);

		$('#clientcreditcard-credit_card_type_id').on('change', function click(e)
		{
			var $self                   = $(this),
				card_type               = $self.val(),
				$branch_type            = $("#clientcreditcard-credit_card_type_branch_id");

			// show amex card type
			if (card_type === "1") {
				$branch_type.removeClass('hidden').find('input').prop('disabled', false);

				// show the container
				$branch_type.closest('.form-group').removeClass('hidden');

			} else {
				// hide and disable the field
				$branch_type.addClass('hidden').find('input').prop('disabled', true);

				// hide the container
				$branch_type.closest('.form-group').addClass('hidden');
			}

			Adzuki.CardNumberEntry.amexTokenization($self.closest('.cc-form'));
		});

		$('#clientcreditcard-client_address_id').on('change', function click(e) {
			if ($('#client_credit_card_create').val() === 'true') {
				if ($(this).val() === '') {
					$('.primary_client_address_section').removeClass('hidden');
				} else if ($(this).val() !== '') {
					$('.primary_client_address_section').addClass('hidden');
					$('#clientcreditcard-primary_client_address-1').click().trigger('change');
				}
			}
		});

		$('#clientcreditcard-primary_client_address-0').on('change', function handlePrimaryAddressYes(e) {
			if ($(this).val() === 'Yes') {
				$('.required_address_field').removeClass('hidden');
			}
		});

		$('#clientcreditcard-primary_client_address-1').on('change', function handlePrimaryAddressNo(e) {
			if ($(this).val() === 'No') {
				$('.required_address_field').addClass('hidden');
			}
		});
	};

}(jQuery, window.Adzuki || {}));
